var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCancelledEmpty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 114
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ic-cancelled-empty_svg__a",
    x1: "95.577%",
    x2: "3.352%",
    y1: "4.423%",
    y2: "96.648%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#AFB3BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#CFCFCF"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 108 7)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#202E4A",
    strokeLinecap: "round",
    strokeWidth: 3,
    d: "M2 96h15.211"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 75.004,
    cy: 3.78,
    fill: "#FFF",
    stroke: "#202E4A",
    strokeWidth: 2,
    rx: 3.258,
    ry: 3.264
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.65,
    cy: 77.648,
    fill: "#FFF",
    stroke: "#202E4A",
    strokeWidth: 2,
    rx: 4.397,
    ry: 4.405
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 91.172,
    cy: 57.759,
    fill: "#202E4A",
    rx: 2.693,
    ry: 2.699
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.53,
    cy: 20.329,
    fill: "#202E4A",
    rx: 1.629,
    ry: 1.632
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#202E4A",
    strokeLinecap: "round",
    strokeWidth: 3,
    d: "M25 96h44.112M78 96h23.582"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ic-cancelled-empty_svg__a)",
    d: "M17.092 38.275L57.964 9l1.754 3 .41 6.673c-3.788.487-5.859 2.367-6.212 5.64-.354 3.272 1.58 5.482 5.802 6.628l.41 6.637-3.94 2.2H19.747l-2.655-1.503z",
    transform: "rotate(-27 113.961 -10.786)"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#202E4A",
    strokeWidth: 2.961
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.49 50.441l3.25 6.377c.412.809.09 1.798-.718 2.21L43.09 81.413a1.643 1.643 0 01-2.21-.719l-3.25-6.376c2.876-1.466 4.015-4.994 2.544-7.88-1.471-2.887-4.995-4.04-7.87-2.575l-3.25-6.377a1.643 1.643 0 01.719-2.21l43.932-22.384a1.643 1.643 0 012.21.718l3.249 6.377c-2.876 1.465-4.014 4.993-2.543 7.88 1.47 2.887 4.994 4.04 7.87 2.574z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M46.715 57.755l12.05-6.14M51.21 66.576l19.054-9.71"
  })), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 4.929,
    d: "M39.123 91.727l36.827-71.04"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#202E4A",
    strokeWidth: 2.961,
    d: "M43.15 89.675L74.96 27.21"
  })))));
}
export default SvgIcCancelledEmpty;